import { registerPlugin } from '@capacitor/core';
import { isAndroidNative } from './capacitorPlatform';
import { getEndpointCandidates } from '../config/apiConfig';
import { readStoredAuth } from '../api/authApi';
import { visitasListScope } from '../services/visitasOfflineList';
import { activosCatalogScope } from '../services/activosCatalogIdentity';

const NativePreparation=registerPlugin('VisitasPreparation');
export function buildPreparationConfiguration(session,{scope,timezone,url},now=Date.now()) {
    const offlineUntil=Number(session?.offline_expires_at||0),expires=Date.parse(session?.expires_at||'');
    const validUntil=Number.isFinite(expires)?Math.min(offlineUntil,expires):offlineUntil;
    const preservePrepared=!!(scope && visitasListScope(session?.user)===scope && offlineUntil>now);
    return {enabled:!!(session?.token && preservePrepared && validUntil>now && timezone && url),preservePrepared,
        catalogEnabled:!!(scope&&activosCatalogScope(session?.user)===scope),catalogUrl:url?url.replace(/\/react\/visitas\/?$/,'/react/activos/catalogo-offline'):'',
        token:session?.token||'',scope,timezone,url,validUntil};
}
export const disableVisitasPreparation = () => isAndroidNative()?NativePreparation.configure({enabled:false}):Promise.resolve({});
export async function configureVisitasPreparation({token,scope,timezone,isCurrent=()=>true}) {
    if(!isAndroidNative()) return {};
    const session=await readStoredAuth();
    if(!isCurrent())return {};
    const url=getEndpointCandidates('visitas','list',{isEndpointKey:true}).find(item=>item.backend==='php')?.url;
    const configuration=await NativePreparation.configure(buildPreparationConfiguration(session,{scope,timezone,url}));
    return {
        takePrepared:()=>NativePreparation.getPrepared(),
        acknowledge:generation=>NativePreparation.acknowledge({generation}),
        markPrepared:day=>NativePreparation.markPrepared({day,scope}),
        requestNow:({refresh=false}={})=>NativePreparation.requestNow({scope,refresh}),
        dispose:()=>NativePreparation.disable({generation:configuration.generation,scope}),
    };
}
